angular.module( 'acme.view.application.membership.levels.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.directive.upload',
  'acme.common.directive.integer',
  'acme.common.directive.numeric',
  'acme.view.application.membership.levels.create.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipLevelsCreate = {
        name: 'application.membership.levels.create',
        url: '/create?group&groupId&auxiliary',
        views: {
          "subview-main@application": {
            templateUrl: 'views/application/views/membership/levels/create/create.tpl.html',
            controller: 'MembershipLevelsCreateController'
          }
        },
        data: {
          pageTitle: 'Create Membership Level',
          permissions: ['MEMBERSHIP_CATEGORY_CREATE'],
          enablePreferences: true
        },
        resolve: {
          bootstrap: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/bootstrap.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernote: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/summernote.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernoteCss: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.loadCss( "/assets/summernote.css", 'summernote', function() {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          MembershipLevelCollections: ['PermissionsService', 'HelpersService', 'ApiService', function(PermissionsService, HelpersService, ApiService) {
            if (PermissionsService.check('MEMBERSHIP_LEVEL_COLLECTION_VIEW')) {
              return ApiService.membership.categories.collection.list(HelpersService.getPaginator({sortField: 'displayOrder'}));
            } else {
              return {
                data: false
              };
            }
          }]
        }
      },
      membershipLevelsEdit = {
        name: 'application.membership.levels.edit',
        url: '/:categoryId/edit',
        views: {
          "subview-main@application": {
            templateUrl: 'views/application/views/membership/levels/create/create.tpl.html',
            controller: 'MembershipLevelsCreateController'
          }
        },
        data: {
          pageTitle: 'Edit Membership Level',
          permissions: ['MEMBERSHIP_CATEGORY_UPDATE'],
          enablePreferences: true
        },
        resolve: {
          bootstrap: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/bootstrap.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernote: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/summernote.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernoteCss: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.loadCss( "/assets/summernote.css", 'summernote', function() {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          MembershipLevelCollections: ['PermissionsService', 'HelpersService', 'ApiService', function(PermissionsService, HelpersService, ApiService) {
            if (PermissionsService.check('MEMBERSHIP_LEVEL_COLLECTION_VIEW')) {
              return ApiService.membership.categories.collection.list(HelpersService.getPaginator({sortField: 'displayOrder'}));
            } else {
              return {
                data: false
              };
            }
          }]
        }
      };

    $stateProvider
      .state(membershipLevelsCreate)
      .state(membershipLevelsEdit);
});
